// extracted by mini-css-extract-plugin
module.exports = {"container":"price-range_container__5XN9T","containerV2":"price-range_containerV2__k0SNS","fullPrice":"price-range_fullPrice__P3x9y","finalPrice":"price-range_finalPrice__jQCbH"};